import type { AccountFlow, AccountResponse, DashboardSummariesResponse } from '@shared/api';

export class AccountUtils {
  static filterAccounts = (features: AccountFlow[] | null, accounts: AccountResponse[]) =>
    accounts.filter((acc) => features?.find((a) => a.accountId === acc.id)?.view);

  static filterDashboardAccounts = (accounts: DashboardSummariesResponse[], filters: { searchText?: string; currency?: string }) => {
    let result = accounts;

    result = result.filter((account) => !filters.currency || account.currency === filters.currency);

    if (filters.searchText) {
      const lowerCaseSearchText = filters.searchText.toLowerCase();

      result = result.filter(
        (account) =>
          account.accountName.toLowerCase().includes(lowerCaseSearchText) ||
          account.accountNumber?.toLowerCase().includes(lowerCaseSearchText) ||
          account.currency?.toLowerCase().includes(lowerCaseSearchText) ||
          account.iban?.toLowerCase().includes(lowerCaseSearchText),
      );
    }

    return result;
  };

  static groupedDashboardAccounts = (accounts: DashboardSummariesResponse[]) => {
    const mainAccountsMap = new Map<number, DashboardSummariesResponse>();
    const subAccountsGrouped: Record<number, DashboardSummariesResponse[]> = {};
    const result: { mainAccount: DashboardSummariesResponse; subAccounts: DashboardSummariesResponse[] }[] = [];

    accounts.forEach((account) => {
      if (account.mainAccId === null) {
        mainAccountsMap.set(account.id, account);
        subAccountsGrouped[account.id] = [];
      }
    });

    accounts.forEach((account) => {
      if (account.mainAccId !== null) {
        const parent = mainAccountsMap.get(account.mainAccId);
        if (parent) subAccountsGrouped[account.mainAccId!].push(account);
        else result.push({ mainAccount: account, subAccounts: [] });
      }
    });

    for (const [mainId, mainAccount] of mainAccountsMap.entries()) {
      result.push({ mainAccount, subAccounts: subAccountsGrouped[mainId] || [] });
    }

    return result;
  };
}
